import { render, staticRenderFns } from "./BackgroundContainer.vue?vue&type=template&id=24301b18&scoped=true&"
import script from "./BackgroundContainer.vue?vue&type=script&lang=js&"
export * from "./BackgroundContainer.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundContainer.vue?vue&type=style&index=0&id=24301b18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24301b18",
  null
  
)

export default component.exports